import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.91602 4.58232L5.16602 6.33232M10.584 0.517072C10.6394 0.49797 10.699 0.494827 10.756 0.508001C10.8131 0.521174 10.8653 0.550134 10.9067 0.591569C10.948 0.633005 10.9769 0.685245 10.99 0.742319C11.0031 0.799392 10.9999 0.858998 10.9807 0.914322L7.52502 10.7902C7.50434 10.8492 7.4664 10.9006 7.41612 10.9379C7.36583 10.9751 7.30553 10.9963 7.24303 10.9988C7.18053 11.0013 7.11871 10.985 7.0656 10.952C7.01249 10.9189 6.97054 10.8707 6.94518 10.8135L5.06743 6.58899C5.03612 6.51855 4.97979 6.46222 4.90935 6.4309L0.68485 4.55257C0.627856 4.52713 0.579801 4.48517 0.546894 4.43213C0.513987 4.3791 0.497741 4.31741 0.500253 4.25504C0.502765 4.19267 0.523921 4.13249 0.560987 4.08227C0.598053 4.03205 0.649327 3.9941 0.708184 3.97332L10.584 0.517072Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSend;
